export default class AuthUser{
  public email: string = '';

  public password: string = '';

  public apiToken: string = '';

  public accessToken: string = '';

  public tokenType: string = '';

  public expiresIn: number = 0;

  public createdAt: number = 0;

  constructor(data: any = {}) {
    this.email = data.email || '';
    this.password = data.password || '';
    this.apiToken = data.api_token || '';
    this.accessToken = data.access_token || '';
    this.tokenType = data.token_type || '';
    this.expiresIn = data.expires_in || 0;
    this.createdAt = data.created_at || 0;
  }

  public formatPayload(): any {
    return {
      email: this.email,
      password: this.password,
      api_token: this.apiToken,
    };
  }

  public formatAuthPayload(): any {
    return {
      access_token: this.accessToken,
      token_type: this.tokenType,
      expires_in: this.expiresIn,
      created_ast: this.createdAt
    };
  }
}
